<template>
  <div class="text-center">
    <h1>418</h1>
    <p>Item not found in cache</p>
    <p>Return online to continue</p>
    <Button
      class="p-button-sm"
      label="Go Back"
      icon="pi pi-caret-left"
      @click="$router.go(-1)"
    />
  </div>
</template>
